import {TaskStatus} from "types/tasks"
import {useTaskUserPolling} from "../../../hooks/useTaskUserPolling"
import {TaskProcessing} from "./TaskProcessing"

type Props = {
    taskId: number
    taskUser: {taskUserId: number; subTaskId?: number}
    onSettled: (status: TaskStatus) => void
}

// Compact waiting state for the task detail: shows the processing task user of the current user and keeps polling it
export function TaskProcessingNotice({taskId, taskUser, onSettled}: Props) {
    const {isTimedOut, refresh} = useTaskUserPolling({
        taskId,
        subTaskId: taskUser.subTaskId,
        taskUserId: taskUser.taskUserId,
        enabled: true,
        onSettled
    })

    return <TaskProcessing compact isTimedOut={isTimedOut} onRefresh={refresh} />
}
